"use client"

import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import * as authHandlers from '../redux/handlers'
import { isAuthenticated } from '../../../utils/auth'


const schema = yup.object().shape({
    mobile: yup
        .string()
        .matches(/^[6-9]\d{9}$/, "**Please enter a valid 10-digit mobile number.")
        .required("**Please enter your mobile number")
});


function Login(props) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { loading: isLoading, error: serverError } = useSelector(state => state.auth)

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        if (isAuthenticated()) {
            navigate("/admin/home", { replace: true });
        }

        dispatch(authHandlers.clearErrorHandler())
    }, [dispatch, navigate])


    const onSubmitHandler = async (submitData) => {
        const formData = {
            ...submitData,
            mobile: `+91${submitData.mobile}`
        }
        const response = await dispatch(authHandlers.loginHandler(formData))
        console.log("response", response);
        if (response?.status === 200) {
            navigate("/auth/verify", { replace: true, state: { data: formData } });
        }
    }

    const onErrorHandler = (errors) => {
        console.log("error \n", errors, serverError)
    }

    return (
        <div className="flex items-center justify-center min-h-screen" style={{ backgroundColor: '#1a1a1a' }}>
            <div className="w-full max-w-md px-8">
                <form onSubmit={handleSubmit(onSubmitHandler, onErrorHandler)} className="space-y-4">
                     <div className="flex justify-between items-center mb-8">
                        <h1 className="text-6xl text-white text-center">
                            Login
                        </h1>
                        <div className="w-11 h-11 rounded-full border border-gray-700 flex items-center justify-center">
                            <span className="text-gray-400" style={{ fontSize: '20px' }}>⚡</span>
                        </div>
                    </div>
                    
                    <div className="space-y-3">
                        <div className="relative">
                            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none" style={{ fontSize: '15px' }}>
                                +91
                            </span>
                            <input 
                                {...register('mobile')} 
                                id="mobile" 
                                type="tel"
                                placeholder="Mobile"
                                maxLength="10"
                                className="w-full pl-14 pr-4 text-white placeholder-gray-600 border border-gray-700 rounded-xl focus:outline-none focus:border-gray-600 transition-colors" 
                                style={{ 
                                    backgroundColor: 'transparent',
                                    height: '52px',
                                    fontSize: '15px'
                                }}
                                autoComplete="tel"
                            />
                        </div>
                        
                        {errors?.mobile && (
                            <p className="text-red-500 pl-1" style={{ fontSize: '14px' }}>
                                {errors.mobile.message}
                            </p>
                        )}
                        {serverError && !errors?.mobile && (
                            <p className="text-red-500 pl-1" style={{ fontSize: '14px' }}>
                                {serverError?.data?.detail?.message}
                            </p>
                        )}
                    </div>
                    
                    <button 
                        type="submit" 
                        disabled={isLoading}
                        className="w-full text-white font-medium rounded-xl hover:opacity-90 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed transition-opacity"
                        style={{ 
                            backgroundColor: '#7c5cff',
                            height: '52px',
                            fontSize: '16px'
                        }}
                    >
                        {isLoading ? "Sending..." : "Send OTP"}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default Login